module.exports = __webpack_public_path__ + "img/people-empty.ea859c44.svg";